import { Component, Input } from '@angular/core';

@Component({
    selector: 'loading-bar',
    templateUrl: './loading-bar.component.html',
    styleUrls: ['./loading-bar.component.css'],
    standalone: false
})
export class LoadingBarComponent {
  @Input() label: string = "Loading";
}
